import Gravity from "Gravity";

const contactUsFooterForm = () => {
    const footerForm = document.querySelector(".gg-footer-contact-form");
    if (!footerForm) {
        return;
    }

    /* eslint-disable */
    jQuery(document).ready(() => {
        jQuery(document).on("gform_confirmation_loaded", (_e, formID) => {
            document
                .querySelector(`#gform_confirmation_wrapper_${formID}`)
                .closest(".gg-footer__form-column")
                ?.classList.add("gg-footer-form__successful");

            const pardotCookieBarYesBtn = document.getElementById(
                "pi_tracking_opt_in_yes",
            );
            pardotCookieBarYesBtn?.click();
        });
    });
    /* eslint-enable */
};
Gravity.ready(contactUsFooterForm);
